import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { color, border, mediaQuery } = baseVariables;

export const StyledPreferredPaymentInfo = styled.div`
  background-color: ${color.neutral10};
`;

export const StyledPreferredPaymentForm = styled.div`
  padding: ${toRem(40)} ${toRem(16)} 0;
  border: ${toRem(1)} ${border.borderStyleDefault} ${color.neutral20};
  background-color: ${color.base20};
  box-shadow: 0 0 ${toRem(8)} 0 rgba(0, 0, 0, 0.07);

  @media ${mediaQuery.md} {
    padding: ${toRem(40)} ${toRem(60)} 0;
    border-radius: ${toRem(12)};
  }

  @media ${mediaQuery.lg} {
    padding: ${toRem(40)} ${toRem(94)} 0;
  }
`;

export const StyledCtaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${toRem(32)} 0;

  .submit-cta {
    width: 90%;
  }

  @media ${mediaQuery.md} {
    justify-content: flex-end;

    .submit-cta {
      width: auto;
    }
  }
`;
